import { NgModule } from '@angular/core';
import { ViewerComponent } from './viewer/viewer';
import { IonicModule } from 'ionic-angular'
import { DriversLicenseScannerComponent } from './drivers-license-scanner/drivers-license-scanner';
import { UploadInsuranceComponent } from './upload-insurance/upload-insurance';
import { UploadPrescriptionComponent } from './upload-prescription/upload-prescription';
import { DirectivesModule } from '../directives/directives.module';

@NgModule({
	declarations: [ViewerComponent, DriversLicenseScannerComponent,
    UploadInsuranceComponent,
    UploadPrescriptionComponent],
	imports: [IonicModule, DirectivesModule],
	exports: [ViewerComponent, DriversLicenseScannerComponent,
    UploadInsuranceComponent,
    UploadPrescriptionComponent]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts